import http from '../../../../../../common/utils/http'
import { API_BASE_URL } from '../../../../../../common/utils/commonUrl'
import Vue from 'vue'
import { Card, Search } from 'vant'
import { DOWNLOAD_FILE } from '../../../../../../common/utils/uploadFileUtil'
import * as RoutePathConstants from '../../../../../../constants/RoutePathConstants'
import { Empty } from 'vant';

Vue.use(Empty);
Vue.use(Card)
Vue.use(Search)
export default {
  data () {
    return {
      value: '',
      list: [],
      channel: '',
      id: '',
    }
  },

  methods: {
    getCommodityPageList () {
      http.get(`${API_BASE_URL}/api/wxoa/pmall/wxoaPmall/getCommodityPageList?classificationLevel3=${this.id}&channel=${this.channel}&pageSize=100&pageNum=1`).then(
        res => {
          this.list = res.data.data.dataList.map(item => {
            let img = `${DOWNLOAD_FILE}${item.codeToFileIds.details[0]}?X-Authorization=${localStorage.getItem('token')}`
            return {
              img,
              ...item
            }
          })
        }
      )
    },
    openCommodityDetails (item) {
      this.$router.push({
        path: RoutePathConstants.PRODUCT_DETAILS,
        query: {
          id: item.id
        }
      })
    },
  },
  mounted () {
    if (this.$route.query.channel) {
      this.channel = this.$route.query.channel
    } else {
      this.id = this.$route.query.id
    }
    this.getCommodityPageList()
  }
}



// WEBPACK FOOTER //
// ./src/pages/wx-member/points-mall/points-mail-home-page/views/commodity-class/commodity-class.js